module.exports = __webpack_public_path__ + "img/jpeg.39b040bd.png";